import BodyContentClient from "./BodyContent.client";
import Heading from "../Heading";
import Image from "next/image";

interface BodyContentProps {
	heading?: string;
	headingTag?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
	headingClassName?: string;
	rating?: string;
	reviewRating?: number;
	reviewCount?: number;
	reviewsHref?: string;
	fullText: string;
	containerClassName?: string;
	className?: string;
	additionalContent?: React.ReactNode;
	contecttextclass?: string;
}

function HeadingReviewMeta({
	reviewRating,
	reviewCount,
	reviewsHref = "#customer-reviews",
}: {
	reviewRating: number;
	reviewCount: number;
	reviewsHref?: string;
}) {
	if (reviewRating <= 0 && reviewCount <= 0) return null;

	return (
		<div className="flex items-center gap-2 shrink-0">
			{reviewRating > 0 && (
				<p className="text-[13px] leading-none">
					<span className="font-bold text-black md:font-normal md:text-[#5F6B7A]">
						{reviewRating.toFixed(1)}
					</span>
					<span className="font-normal text-[#5F6B7A]"> /</span>
					<span className="text-[11px] font-normal text-[#5F6B7A]"> 5</span>
				</p>
			)}
			{reviewRating > 0 && (
				<Image
					src="https://static-asset.tractorjunction.com/cj/yellow-star.svg"
					alt="Rating"
					title="Rating"
					width={12}
					height={12}
					className="size-3"
				/>
			)}
			{reviewCount > 0 && (
				<a href={reviewsHref} className="text-[13px] font-normal text-[#155DFC] hover:underline">
					{reviewCount} Reviews
				</a>
			)}
		</div>
	);
}

const BodyContent = ({
	heading,
	headingTag = "h2",
	headingClassName = "mb-4",
	rating,
	reviewRating,
	reviewCount,
	reviewsHref,
	fullText,
	containerClassName = "container mx-auto px-4 sm:px-6 lg:px-8",
	className,
	additionalContent,
	contecttextclass,
}: BodyContentProps) => {
	const hasStructuredReviews =
		(reviewRating !== undefined && reviewRating > 0) || (reviewCount !== undefined && reviewCount > 0);

	return (
		<div className={containerClassName}>
			{heading && (
				<div
					className={
						hasStructuredReviews
							? "flex flex-col gap-2 md:flex-row md:flex-wrap md:items-center md:gap-3 mb-3 md:mb-3"
							: "flex flex-row items-center gap-2"
					}
				>
					<Heading tag={headingTag} className={hasStructuredReviews ? `${headingClassName} !mb-0` : headingClassName}>
						{heading}
					</Heading>
					{hasStructuredReviews ? (
						<HeadingReviewMeta
							reviewRating={Number(reviewRating ?? 0)}
							reviewCount={Number(reviewCount ?? 0)}
							reviewsHref={reviewsHref}
						/>
					) : (
						rating && (
							<div className="flex items-center gap-1 md:mb-3">
								<Image
									src={`${process.env.NEXT_PUBLIC_CDN_STATIC_URL}yellow-star.svg`}
									width={10}
									height={10}
									alt="rating"
									title="rating"
								/>
								<span className="font-bold text-[11px]">{rating}</span>
							</div>
						)
					)}
				</div>
			)}

			<BodyContentClient fullText={fullText} className={className} additionalContent={additionalContent} contecttextclass={contecttextclass} />
		</div>
	);
};

export default BodyContent;
